import { render, staticRenderFns } from "./BaseComboBox.vue?vue&type=template&id=028e2115&scoped=true"
import script from "./BaseComboBox.vue?vue&type=script&lang=js"
export * from "./BaseComboBox.vue?vue&type=script&lang=js"
import style0 from "./BaseComboBox.vue?vue&type=style&index=0&id=028e2115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e2115",
  null
  
)

export default component.exports